import { statusNames } from '../model/constants';
import { ConditionStatus } from '../model/types';
import styles from './styles.module.scss';
import { InlineSvg } from 'components/svg';
import { useMemo } from 'react';

export const useVhcBlock = ({ conditionId }: { conditionId: ConditionStatus }) => {
  const statusIcon = useMemo(() => {
    switch (conditionId) {
      case ConditionStatus.OK:
        return (
          <span className={styles.statusOk}>
            <div>
              <InlineSvg path="/media/icons/duotune/general/gen043.svg" className="svg-icon-1 text-success" />
            </div>
            <div>{statusNames[conditionId]}</div>
          </span>
        );
      case ConditionStatus.WARNING:
        return (
          <span className={styles.statusWarning}>
            <div>
              <InlineSvg path="/media/icons/duotune/general/gen044.svg" className="svg-icon-1 text-warning" />
            </div>
            <div>{statusNames[conditionId]}</div>
          </span>
        );
      case ConditionStatus.NOT_OK:
        return (
          <span className={styles.statusNotOk}>
            <div>
              <InlineSvg path="/media/icons/duotune/general/gen040.svg" className="svg-icon-1 text-white" />
            </div>
            <div>{statusNames[conditionId]}</div>
          </span>
        );
      case ConditionStatus.NOT_TESTED:
        return (
          <span className={styles.statusNotTested}>
            <div>{statusNames[conditionId]}</div>
          </span>
        );
      default:
        return (
          <span className={styles.statusNotTested}>
            <div>NOT TESTED</div>
          </span>
        );
    }
  }, [conditionId]);

  const blockClass = useMemo(() => {
    switch (conditionId) {
      case ConditionStatus.OK:
        return styles.blockOk;
      case ConditionStatus.WARNING:
        return styles.blockWarning;
      case ConditionStatus.NOT_OK:
        return styles.blockNotOk;
      case ConditionStatus.NOT_TESTED:
        return styles.blockNotTested;
      default:
        return '';
    }
  }, [conditionId]);

  return {
    statusIcon,
    blockClass
  };
};
